import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from '@mui/material/styles';

const ErrorContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  textAlign: 'center',
  height: '100%',
}));

const StyledErrorIcon = styled(ErrorOutlineIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.error.main,
  marginBottom: theme.spacing(2),
}));

interface LoaderErrorProps {
  title: string;
  children?: React.ReactNode;
}

const LoaderError: React.FC<LoaderErrorProps> = ({ title, children }) => {
  return (
    <ErrorContainer>
      <StyledErrorIcon />
      <Typography variant="h5" color="error" gutterBottom>
        {title}
      </Typography>
      {children && (
        <Typography variant="body1" color="text.secondary">
          {children}
        </Typography>
      )}
    </ErrorContainer>
  );
};

export default LoaderError;
